import {
  ADMIN_API_METHOD_TYPES,
  type AdminToastRequest,
  type ADMIN_MESSAGE_TYPES,
  type AdminMessagePayloads,
} from './types.admin'
import { usePostRobot } from '@lib/sdk/utils/postrobot'
import * as appErrorsAdmin from './app-errors.admin'
import * as envAdmin from './env.admin'
import * as canvasAdmin from './canvas.admin'
import * as metadataTemplatesAdmin from './metadataTemplates.admin'
import * as filesAdmin from './files.admin'
import * as contentAdmin from './content.admin'
import * as usersAdmin from './users.admin'
/**
 * Subscribe to a given event type by its key.
 *
 * @param type The event type/key to subscribe to.
 * @param handler The handler function to call when the event is emitted.
 * @returns A Promise resolving to a cleanup function to unsubscribe from the event.
 */

async function on(
  type: (typeof ADMIN_MESSAGE_TYPES)[keyof typeof ADMIN_MESSAGE_TYPES],
  handler: (data: AdminMessagePayloads[typeof type]) => Promise<void>,
) {
  const pr = await usePostRobot()
  const listener = pr.on(type, (e) => handler(e.data))

  // return the cleanup function
  return listener.cancel
}

/**
 * Show a toast message to the user. Compatible with the UI API version of this method.
 *
 * @example
 * useAdmin().toast({ type: 'info', message: 'Hello, world!' })
 */
async function toast(payload: AdminToastRequest): Promise<void> {
  const pr = await usePostRobot()
  await pr.send(window.parent, ADMIN_API_METHOD_TYPES.TOAST, payload)
}

export default {
  on,
  toast,
  ...appErrorsAdmin,
  ...contentAdmin,
  ...envAdmin,
  ...canvasAdmin,
  ...metadataTemplatesAdmin,
  ...filesAdmin,
  ...usersAdmin,
}
